"use strict";
var cwise = require('cwise');
var PaletteAoMesher_1 = require('../meshers/PaletteAoMesher');
var TexturedAoMesher_1 = require('../meshers/TexturedAoMesher');
var AoMesher_1 = require('../meshers/AoMesher');
var aoAssign = cwise({
    args: ['array', 'scalar'],
    body: function (a, ob) {
        if (a) {
            a = a | ob;
        }
    }
});
var paletteAoMesher = new PaletteAoMesher_1.default();
var texturedAoMesher = new TexturedAoMesher_1.default();
function createObjectVao(gl, voxels, palette, pad) {
    var padded = paletteAoMesher.pad(voxels);
    // TODO: Think of alternatives of using opaque bit
    aoAssign(padded, AoMesher_1.OPAQUE_BIT);
    return paletteAoMesher.build(gl, padded, palette);
}
exports.createObjectVao = createObjectVao;
// Creates a mesh from a set of voxels
function createVoxelMesh(gl, voxels, voxelSideTextureIDs, voxelSideTextureSizes) {
    return texturedAoMesher.build(gl, texturedAoMesher.pad(voxels), voxelSideTextureIDs, voxelSideTextureSizes);
}
exports.createVoxelMesh = createVoxelMesh;
//# sourceMappingURL=buffer.js.map


/*****************
 ** WEBPACK FOOTER
 ** /Users/songseunggeun/voxeline/engine/lib/Mesher/buffer.js
 ** module id = 910
 ** module chunks = 0
 **/